import {createSlice} from '@reduxjs/toolkit'

export const popupSlice = createSlice({
  name: "popup",
  initialState: { name: '' },
  reducers:{
    openPopup: (state, action)=>{
      state.name = action?.payload?.name || ''
      state.phone = action?.payload?.phone || ''
      state.featureName = action?.payload?.featureName || ''
      state.singer = action?.payload?.singer || null
    },
  },
});

export const { openPopup } = popupSlice.actions

export default popupSlice.reducer
